// extracted by mini-css-extract-plugin
module.exports = {"main":"Main_main__2zd4R","game":"Main_game__1rjBz"};